import gql from 'graphql-tag';

export const GET_STATEMENT_CSV = gql`
  query getStatementCsv($statementId: Int!) {
    statement(id: $statementId) {
      id
      csv
    }
  }
`;

export const getStatementCsvMock: () => GetStatementCsvQuery = () => ({
  statement: {
    id: 2,
    csv: 'somecsv',
  },
});
